<template>
  <div>
    <app-header @expand="callFullscreen" @changeMenu="changeParentMenu" v-if="this.$store.state.menu.flag.headerUse"/>
    <navigation/>
    <!-- 즐겨찾기 -->
<!--    <book-mark/>-->
    <v-main>
      <tag-view v-show="$vuetify.breakpoint.mdAndUp && showTagView"/>
      <v-container :class="[{'mt-10' : showTagView && $vuetify.breakpoint.mdAndUp},'pa-0']" fluid :style="fullScreenStyle">
        <router-view/>
      </v-container>
    </v-main>
    <app-footer v-if="this.$store.state.menu.flag.footerUse"/>
    <!-- top button -->
    <v-btn v-scroll="onScroll" v-show="fab" small fab dark fixed bottom right color="primary" @click="toTop" style="z-index: 5; bottom: 8px;">
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </div>
</template>
<script>
import appHeader from '@/layout/components/AppHeader.vue'
import appFooter from '@/layout/components/AppFooter.vue'
import navigation from '@/layout/components/Navigation.vue'
import tagView from '@/layout/components/TagView.vue'
import bookMark from '@/layout/components/BookMark.vue'
import DispatchResize from '@/mixins/DispatchResize'
import store from '@/store'
import _ from 'lodash'
import envs from '@/envs'
import { openFullscreen } from '@/utils/jglib'

export default {
  name: 'layout',
  components: {
    appHeader,
    appFooter,
    navigation,
    tagView,
    bookMark
  },
  mixins: [DispatchResize()],
  data: () => ({
    drawerRight: false,
    fullScreenStyle: {},
    fab: false,
    tempNavigationDrawer: false,
    tempTagView: false
  }),
  watch: {
    $route(to) {
      this.changeRoute()
      this.$nextTick(() => {
        this.dispatchResize()
      })
    },
    // 메뉴를 다시 불러올 경우 현재 위치를 기준으로 다시 재 구성
    '$store.state.menu.menus'(newVal) {
      if (newVal.length !== 0) this.changeRoute()
    }
  },
  computed: {
    childrenMenus() {
      let currentMenu = store.state.menu.selectedMenu.menu_id
      if (!currentMenu) currentMenu = envs.framework.template.home
      let childrenMenus = []
      let targetMenu = _.find(store.state.menu.treeMenus, {
        menu_id: currentMenu
      })
      if (targetMenu && targetMenu.children) childrenMenus = targetMenu.children
      return childrenMenus
    },
    highMenus() {
      return store.state.menu.menus.filter(menu => (menu.menulevel | 0) === 1)
    },
    drawer() {
      return store.state.menu.flag.navigationDrawer
    },
    visitedViews() {
      return store.state.tagsView.visitedViews
    },
    showTagView() {
      // tag-view 사용 여부와, 1개 일 경우 tag-view는 출력되지 않는다.
      if (!this.$store.state.menu.flag.tagViewUse) {
        return false
      }
      if (this.$store.state.tagsView.visitedViews.length <= 1) {
        // 두개부터 출력되는 경우
        if (this.$store.state.tagsView.viewType === 'FROM_TWO') {
          return false
        }
      }
      return true
    }
  },
  mounted() {
    document.addEventListener('fullscreenchange', (event) => {
      if (!document.fullscreenElement) {
        store.dispatch('SetFooterUse', true)
        store.dispatch('SetHeaderUse', true)
        store.dispatch('SetNavigationDrawer', this.tempNavigationDrawer)
        store.dispatch('SetTagViewUse', this.tempTagView)
        this.fullScreenStyle = {}
      }
    })
    // IE11
    document.addEventListener('MSFullscreenChange', (event) => {
      if (!document.msFullscreenElement) {
        store.dispatch('SetFooterUse', true)
        store.dispatch('SetHeaderUse', true)
        store.dispatch('SetNavigationDrawer', this.tempNavigationDrawer)
        store.dispatch('SetTagViewUse', this.tempTagView)
        this.fullScreenStyle = {}
      }
    })
  },
  methods: {
    changeParentMenu(menu) {
      store.dispatch('SetSelectedMenu', menu)
      if (!menu.children) {
        // 하위 메뉴가 없을 경우, 그곳으로 redirect 한다.
        this.$router.push(menu.href).catch(() => {})
        store.dispatch('SetShowAsideMenu', false)
        this.$store.dispatch('SetNavigationDrawer', false)
      } else {
        // 상단 메뉴를 선택할 경우 무조건 메뉴를 출력한다.
        store.dispatch('SetShowAsideMenu', true)
        this.$store.dispatch('SetNavigationDrawer', true)
      }
    },
    changeRoute() {
      let currentUrl = this.$route.path
      // 각 1depth 아래 메뉴들을 찾는 기능
      function deepSearchMenuTree(target) {
        if (target.href === currentUrl) {
          return true
        }

        if (target.children) {
          for (let menu of target.children) {
            if (deepSearchMenuTree(menu)) return true
          }
        }
        return false
      }
      let tabIndex = 0
      for (let highMenu of this.highMenus) {
        if (deepSearchMenuTree(highMenu)) {
          store.dispatch('SetSelectedMenu', highMenu)
          store.dispatch('SetTabIndex', tabIndex)
          break
        }
        tabIndex++
      }
    },
    callFullscreen() {
      this.tempNavigationDrawer = this.drawer
      this.tempTagView = store.state.menu.flag.tagViewUse
      store.dispatch('SetFooterUse', false)
      store.dispatch('SetHeaderUse', false)
      store.dispatch('SetNavigationDrawer', false)
      store.dispatch('SetTagViewUse', false)
      openFullscreen(document.body)
      this.fullScreenStyle = {
        'position': 'fixed',
        'overflow-y': 'auto',
        'width': '100%',
        'height': 'calc(100% - 40px)'
      }
    },
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 200
    },
    toTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>
<style lang="scss">
.fullscreenDiv {
  width: 100%;
  height: 100%;
}
</style>
